/* eslint-disable require-yield */
import {
  put, select, takeEvery,
} from 'redux-saga/effects';
import { getFilterParamData } from 'src/store/filter/filter-params/selectors';
import { FilterChangeSource, IFilterParams } from 'src/typings/filter';
import { Actions, ActionTypes } from './actions';

export const hasActiveUserFilter = (filterParams: IFilterParams): boolean => {
  return Object.values(filterParams).some((filterParam) => {
    return filterParam?.source === FilterChangeSource.user
      && Boolean(filterParam?.data?.length);
  });
};

export function* setSectionsDataSaga(actions: {
  type: string,
  payload: string[]
}) {
  const markupId = actions.payload?.[0];
  if (!markupId) return;

  const filterParams: IFilterParams = yield select(getFilterParamData);
  if (!hasActiveUserFilter(filterParams)) return;

  yield put(Actions.setSelectedSection({
    markup: 'section_id',
    'markup-id': markupId,
  }));
  yield put(Actions.setSelectedFloor(undefined));
}

export function* setFloorsDataWatchSaga() {
  yield takeEvery(ActionTypes.SET_FILTERED_SECTIONS, setSectionsDataSaga);
}
